import React, { useState, useParams  } from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Slide from "@mui/material/Slide";
import Button from "@mui/material/Button";
import { TextField } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { IconButton, useTheme } from "@mui/material";
import styles from "../styles/AddEditUserModal.module.css";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { useUpdateProjectMutation } from '../store/slices/apis/projectApiSlice';
import { closeSnackbar, openSnackbar } from '../store/slices/snackbar';
import { useDispatch } from '../store';


const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});


const EditProjectModal = ({ open, handleClose, user, onSubmit }) => {

  const theme = useTheme();
  const dispatch = useDispatch();
  const _id = user?.project_id;

  const initialValues = {
    project_name: user?.project_name || "",
    discription: user?.discription || "",
    project_manager_name: user?.project_manager_name || "",
    project_manager_email: user?.project_manager_email || "",
    budgeted_cost: user?.budgeted_cost || "",
    invoiced_cost: user?.invoiced_cost || "",
  };

  const validationSchema = Yup.object().shape({
    project_name: Yup.string().required("Please enter Project Name."),
    discription: Yup.string().required("Please enter Project Description."),
    project_manager_name: Yup.string().required("Please enter Project Manager Name."),
    project_manager_email: Yup.string().email("Invalid email format.").required("Please enter a valid email address."),
    //budgeted_cost: Yup.number().typeError("Budget Cost should have digits only.").required("Please enter Project's Budget Cost."),
    //budgeted_cost: Yup.number().typeError("Invoice Cost should have digits only.").required("Please enter Project's Budget Cost."),
    budgeted_cost: Yup.string().matches(/^\d{1,12}$/, "Budget Cost should have numbers only.").required("Please enter Project's Budgeted Cost."),
    invoiced_cost: Yup.string().matches(/^\d{1,12}$/, "Invoice Cost should have numbers only.").required("Please enter Project's Invoiced Cost."),
  });

  const handleSubmit = (values) => {
    
    const submittedValues = {
      ...values,
    };
    onSubmit(submittedValues);
    handleClose();
  };

  const openNotification = async (msg, type = 'error') => {
      await dispatch(
          openSnackbar({
              open: true,
              message: msg,
              variant: 'alert',
              alert: {
                  color: type
              },
              close: false
          })
      );
      setTimeout(() => dispatch(closeSnackbar()), 3000);
  };

  const [updateProject, { isLoading: isUpdating, error: updateError }] = useUpdateProjectMutation();

  const handleUpdateProject = async (values) => {
    try {
      const submittedValues = {
        ...values,
      };
      const finaldata = { ...user, ...submittedValues, ['project_id']: _id};
      const response = await updateProject({_id, project: finaldata });

      if (response?.data.status == 'success') 
      {
        //openNotification(response?.data.message, 'success');
        openNotification('Project updated successfully.', 'success');
        setTimeout(function() {
          window.location.reload();
        }, 1000);
      }
      else
      {
        openNotification(response?.data.message);
      }
      handleClose();
    } catch (error) {
      openNotification(error?.data.message);
    }
  }


  return (
    <Dialog
      open={open}
      TransitionComponent={Transition}
      keepMounted
      onClose={handleClose}
      aria-describedby="add-project-modal-description"
      sx={{
        "& .MuiDialog-paper": {
          maxWidth: "450px",
          width: "100%",
        },
      }}
    >
      <DialogTitle>
        <h3 className={styles.heading}>
          {user ? "Edit Project Details" : "Add Project Details"}
        </h3>
        <IconButton
          sx={{ position: "absolute", right: 8, top: 8 }}
          onClick={handleClose}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleUpdateProject}
        enableReinitialize
      >
        {({ values, errors, touched, handleChange, setFieldValue }) => (
          <Form>
            <DialogContent>
              <TextField
                label="Project Name"
                name="project_name"
                value={values.project_name}
                onChange={handleChange}
                fullWidth
                error={touched.project_name && Boolean(errors.project_name)}
                helperText={touched.project_name && errors.project_name}
                sx={{
                  mb: 2,
                  "& .MuiInputBase-input": {
                    fontSize: 16,
                  },

                  "& .MuiInputLabel-root": {
                    fontSize: 14,
                  },

                  "& .css-w1u3ce": {
                    fontSize: "12px !important",
                  },

                  "& .MuiFormHelperText-root": {
                    fontSize: "10px !important",
                  },
                }}
              />
              <TextField
                label="Project Description"
                name="discription"
                value={values.discription}
                onChange={handleChange}
                fullWidth
                multiline
                error={touched.discription && Boolean(errors.discription)}
                helperText={touched.discription && errors.discription}
                sx={{
                  mb: 2,
                  "& .MuiInputBase-input": {
                    fontSize: 16,
                  },

                  "& .MuiInputLabel-root": {
                    fontSize: 14,
                  },

                  "& .css-w1u3ce": {
                    fontSize: "12px !important",
                  },

                  "& .MuiFormHelperText-root": {
                    fontSize: "10px !important",
                  },
                }}
              />
              <TextField
                label="Project Manager Name"
                name="project_manager_name"
                value={values.project_manager_name}
                onChange={handleChange}
                fullWidth
                error={touched.project_manager_name && Boolean(errors.project_manager_name)}
                helperText={touched.project_manager_name && errors.project_manager_name}
                sx={{
                  mb: 2,
                  "& .MuiInputBase-input": {
                    fontSize: 16,
                  },

                  "& .MuiInputLabel-root": {
                    fontSize: 14,
                  },

                  "& .css-w1u3ce": {
                    fontSize: "12px !important",
                  },

                  "& .MuiFormHelperText-root": {
                    fontSize: "10px !important",
                  },
                }}
              />
              <TextField
                label="Work Email"
                name="project_manager_email"
                value={values.project_manager_email}
                onChange={handleChange}
                fullWidth
                error={touched.project_manager_email && Boolean(errors.project_manager_email)}
                helperText={touched.project_manager_email && errors.project_manager_email}
                sx={{
                  mb: 2,
                  "& .MuiInputBase-input": {
                    fontSize: 16,
                  },

                  "& .MuiInputLabel-root": {
                    fontSize: 14,
                  },

                  "& .css-w1u3ce": {
                    fontSize: "12px !important",
                  },

                  "& .MuiFormHelperText-root": {
                    fontSize: "10px !important",
                  },
                }}
              />
              <TextField
                label="Budgeted Cost"
                name="budgeted_cost"
                value={values.budgeted_cost}
                onChange={handleChange}
                fullWidth
                error={touched.budgeted_cost && Boolean(errors.budgeted_cost)}
                helperText={touched.budgeted_cost && errors.budgeted_cost}
                sx={{
                  mb: 2,
                  "& .MuiInputBase-input": {
                    fontSize: 16,
                  },

                  "& .MuiInputLabel-root": {
                    fontSize: 14,
                  },

                  "& .css-w1u3ce": {
                    fontSize: "12px !important",
                  },

                  "& .MuiFormHelperText-root": {
                    fontSize: "10px !important",
                  },
                }}
              />
              <TextField
                label="Invoiced Cost"
                name="invoiced_cost"
                value={values.invoiced_cost}
                onChange={handleChange}
                fullWidth
                error={touched.invoiced_cost && Boolean(errors.invoiced_cost)}
                helperText={touched.invoiced_cost && errors.invoiced_cost}
                sx={{
                  mb: 2,
                  "& .MuiInputBase-input": {
                    fontSize: 16,
                  },

                  "& .MuiInputLabel-root": {
                    fontSize: 14,
                  },

                  "& .css-w1u3ce": {
                    fontSize: "12px !important",
                  },

                  "& .MuiFormHelperText-root": {
                    fontSize: "10px !important",
                  },
                }}
              />             
              
            </DialogContent>
            <DialogActions style={{marginBottom: "5px"}}>
              <Button
                onClick={handleClose}
                sx={{
                  border: `1px solid ${theme?.customSettings?.themeColor}`,
                  color: theme?.customSettings?.themeColor,
                  fontSize: "14px",
                  fontWeight: 500,
                  lineHeight: "24px",
                }}
              >
                Cancel
              </Button>
              <Button
                type="submit"
                sx={{
                  background: theme?.customSettings?.themeColor,
                  border: `1px solid ${theme?.customSettings?.themeColor}`,
                  color: "#fff",
                  fontSize: "14px",
                  fontWeight: 500,
                  lineHeight: "24px",
                  marginRight: "20px",
                }}
                disabled={isUpdating}
              >
                {isUpdating ? 'Updating...' : 'Update'}
              </Button>
              {updateError && <p>Error updating product: {updateError.message}</p>}
            </DialogActions>
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};

export default EditProjectModal;
